export { AtnDsAbstractTabs as Component } from './tabs'
